import React, { useState, useCallback, useRef, useEffect } from "react";
import "./styles/Toolbar.css";
import minus from "../../assets/minus.svg";
import plus from "../../assets/plus.svg";
import { Modal } from "react-bootstrap";
import Draggable from "react-draggable";
import { Popup } from "@progress/kendo-react-popup";

const Toolbar = (props) => {
  const [position, setPosition] = useState({
    x: (window.innerWidth || document.documentElement.clientWidth) - 70,
    y:
      0.9 *
      ((window.innerHeight || document.documentElement.clientHeight) - 100),
  });
  const [click, setClick] = useState(false);
  const [startDrag, setStartDrag] = useState(false);

  const stateRef = useRef();
  const tool = useRef();

  stateRef.current = position;

  const handleOnStop = useCallback((e, data) => {
    const documentElement = document.documentElement;
    const wrapperHeight = window.innerHeight || documentElement.clientHeight;
    const wrapperWidth = window.innerWidth || documentElement.clientWidth;

    const center = {
      x: data.x + 30 / 2,
      y: data.y + 30 / 2,
    };

    const margin = {
      left: center.x - 0,
      bottom: wrapperHeight - center.y,
      right: wrapperWidth - center.x,
    };

    const positions = {
      left: {
        x: 0,
        y:
          data.y < 0
            ? 0
            : data.y > wrapperHeight - 16 - 70
              ? wrapperHeight - 16 - 70
              : data.y,
      },
      bottom: { x: data.x, y: wrapperHeight - 50 },
      right: {
        x: wrapperWidth - 70,
        y:
          data.y < 0
            ? 0
            : data.y > wrapperHeight - 16 - 70
              ? wrapperHeight - 16 - 70
              : data.y,
      },
    };
    const sorted = Object.keys(margin).sort((a, b) => margin[a] - margin[b]);
    const nearestSide = sorted[0];

    if (
      Math.abs(positions[nearestSide].x - stateRef.current.x) <= 1 &&
      Math.abs(positions[nearestSide].y - stateRef.current.y) <= 1
    ) {
      setPosition(positions[nearestSide]);
      setClick(true);
    } else {
      setPosition(positions[nearestSide]);
      setClick(false);
    }
    setStartDrag(false);
  }, []);

  const [y, setY] = useState(window.scrollY);

  const handleScroll = useCallback(
    (e) => {
      const window = e.currentTarget;
      if (y !== window.scrollY) {
        setIsOpen(false);
      }
      setY(window.scrollY);
    },
    [y]
  );

  useEffect(() => {
    setY(window.scrollY);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  const handleOnStart = useCallback(() => {
    setStartDrag(true);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const anchor = React.useRef();

  const onClick = () => {
    click ? setIsOpen(!isOpen) : setIsOpen(false);
  };

  const handleKeyPress = useCallback((event) => {
    if (event.altKey && event.key === "b") {
      console.log(`Key pressed: ${event.key}`);
      setIsOpen(true);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  const [show, setShow] = useState(false);
  const modalClose = () => setShow(false);
  return (
    <div className="tool" style={{ zIndex: 100 }}>
      <Draggable
        position={position}
        onStop={(e, data) => handleOnStop(e, data)}
        onStart={() => handleOnStart()}
      >
        <button ref={anchor} className="toggle" onClick={onClick}>
          <div id="rotate" draggable={false}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--background)"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-settings"
            >
              <circle cx="12" cy="12" r="3"></circle>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
            </svg>
          </div>
        </button>
      </Draggable>
      <div className="toolbar" ref={tool}>
        <Popup anchor={anchor.current} show={isOpen}>
          {isOpen && !startDrag ? (
            props.theme === "dark" ? (
              <div
                className="popup-container"
                style={{ backgroundColor: "#F8F5E9" }}
              >
                <h2 style={{ color: "#254E36" }}>Toolbar</h2>

                <table style={{ color: "#254E36" }}>
                  <tr className="fontSizeRow">
                    <td className="labelRow">
                      <p className="labels">Font Size</p>
                    </td>

                    <td>
                      <button
                        style={{ backgroundColor: "#F8F5E9" }}
                        className="fontSizeBtn"
                        onClick={() => props.handleFontSize(false)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#254E36"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-minus"
                        >
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                      </button>
                      <button
                        style={{ backgroundColor: "#F8F5E9" }}
                        className="fontSizeBtn"
                        onClick={() => props.handleFontSize(true)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#254E36"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-plus"
                        >
                          <line x1="12" y1="5" x2="12" y2="19"></line>
                          <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                      </button>
                    </td>
                  </tr>

                  <tr className="scrollToTopRow">
                    <td className="labelRow">
                      <p className="labels">Page Top</p>
                    </td>

                    <td>
                      <button
                        style={{
                          backgroundColor: "#254E36",
                          borderRadius: "50%",
                          aspectRatio: 1,
                        }}
                        className="fontSizeBtn"
                        onClick={() =>
                          window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                          })
                        }
                      >
                        <svg
                          width="24"
                          height="auto"
                          viewBox="0 0 71 84"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 36.5L35.5 3M35.5 3L69 36.5M35.5 3V83.5"
                            stroke="#F8F5E9"
                            stroke-width="3"
                          />
                        </svg>
                      </button>
                    </td>
                  </tr>

                  <tr className="darkModeRow">
                    <td className="labelRow">
                      <p className="labels darkModeLabel">Light/Dark Mode</p>
                    </td>
                    <td>
                      <label className="switch">
                        <input
                          type="checkbox"
                          defaultChecked={true}
                          className="toggle-dark"
                          onClick={() => props.darkModeToggle()}
                          class="toggleBtn"
                        />
                        <span className="slider dark" />
                      </label>
                    </td>
                  </tr>

                  <tr className="keyboardShortcutsRow">
                    <td className="labelRow">
                      <p className="labels keyboardShortcutsLabel">
                        Keyboard Shortcuts
                      </p>
                    </td>
                    <td>
                      <button
                        style={{
                          backgroundColor: "#254E36",
                          borderRadius: "50%",
                          border: "none",
                          aspectRatio: 1,
                        }}
                        className="keyboardShortcutsButton"
                        onClick={() => setShow(true)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="auto"
                          fill="#fff4cb"
                          class="bi bi-keyboard"
                          viewBox="0 0 16 16"
                          marginBottom="px"
                        >
                          <path d="M14 5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12zM2 4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2z" />
                          <path d="M13 10.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm0-2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5 0A.25.25 0 0 1 8.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 8 8.75v-.5zm2 0a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-.5zm1 2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5-2A.25.25 0 0 1 6.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 6 8.75v-.5zm-2 0A.25.25 0 0 1 4.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 4 8.75v-.5zm-2 0A.25.25 0 0 1 2.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 2 8.75v-.5zm11-2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-2 0A.25.25 0 0 1 9.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 9 6.75v-.5zm-2 0A.25.25 0 0 1 7.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 7 6.75v-.5zm-2 0A.25.25 0 0 1 5.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 5 6.75v-.5zm-3 0A.25.25 0 0 1 2.25 6h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5A.25.25 0 0 1 2 6.75v-.5zm0 4a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm2 0a.25.25 0 0 1 .25-.25h5.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-5.5a.25.25 0 0 1-.25-.25v-.5z" />
                        </svg>
                      </button>
                      <div onClick={(e) => e.stopPropagation()}>
                        <Modal
                          dialogClassName="dialog"
                          style={{ paddingRight: "0px !important" }}
                          show={show}
                          onHide={modalClose}
                          centered
                        >
                          <Modal.Header
                            style={{
                              backgroundColor: "#254E36",
                              color: "#F5F5F5",
                            }}
                            className="modalBox"
                            closeButton
                          >
                            <Modal.Title
                              style={{
                                backgroundColor: "#254E36",
                                color: "#F5F5F5",
                              }}
                              className="modalBox"
                            >
                              Keyboard Shortcuts
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body
                            style={{
                              backgroundColor: "#254E36",
                              color: "#F5F5F5",
                            }}
                            className="modalBox"
                          >
                            <ul>
                              <p>
                                <b>Alt d</b> = Dark Mode
                              </p>
                              <p>
                                <b>Alt l</b> = Light Mode
                              </p>
                              <p>
                                <b>Alt /</b> = Home
                              </p>
                              <p>
                                <b>Alt p</b> = Project
                              </p>
                              <p>
                                <b>Alt c</b> = Parts and Contributions
                              </p>
                              <p>
                                <b>Alt h</b> = Human Practices
                              </p>
                              <p>
                                <b>Alt t</b> = Team
                              </p>
                              <p>
                                <b>Alt i</b> = Instagram
                              </p>
                              <p>
                                <b>Alt f</b> = Facebook
                              </p>
                              <p>
                                <b>Alt g</b> = Github
                              </p>
                              <p>
                                <b>Shift ArrowUp</b> = Scroll to Top
                              </p>
                              <p>
                                <b>Shift ArrowDown</b> = Scroll to Bottom
                              </p>
                              <p>
                                <b>Alt b</b> = Open Toolbar
                              </p>
                            </ul>
                          </Modal.Body>
                        </Modal>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            ) : (
              <div
                className="popup-container"
                style={{ backgroundColor: "#254E36" }}
              >
                <h2 style={{ color: "#FFFFFF" }}>Taskbar</h2>

                <table style={{ color: "#FFFFFF" }}>
                  <tr className="fontSizeRow">
                    <td className="labelRow">
                      <p className="labels">Font Size</p>
                    </td>

                    <td>
                      <button
                        style={{ backgroundColor: "#254E36" }}
                        className="fontSizeBtn"
                        onClick={() => props.handleFontSize(false)}
                      >
                        <img src={minus} alt="minus icon" />
                      </button>
                      <button
                        style={{ backgroundColor: "#254E36" }}
                        className="fontSizeBtn"
                        onClick={() => props.handleFontSize(true)}
                      >
                        <img src={plus} alt="minus plus" />
                      </button>
                    </td>
                  </tr>

                  <tr className="scrollToTopRow">
                    <td className="labelRow">
                      <p className="labels">Page Top</p>
                    </td>

                    <td>
                      <button
                        style={{
                          backgroundColor: "#fff4cb",
                          borderRadius: "50%",
                          aspectRatio: 1,
                        }}
                        className="fontSizeBtn"
                        onClick={() =>
                          window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                          })
                        }
                      >
                        <svg
                          width="24"
                          height="auto"
                          viewBox="0 0 71 84"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2 36.5L35.5 3M35.5 3L69 36.5M35.5 3V83.5"
                            stroke="#254E36"
                            stroke-width="3"
                          />
                        </svg>
                      </button>
                    </td>
                  </tr>

                  <tr className="darkModeRow">
                    <td className="labelRow">
                      <p className="labels darkModeLabel">Light/Dark Mode</p>
                    </td>
                    <td>
                      <label className="switch">
                        <input
                          type="checkbox"
                          defaultChecked={false}
                          className="toggle-dark"
                          onClick={() => props.darkModeToggle()}
                          class="toggleBtn"
                        />
                        <span className="slider light" />
                      </label>
                    </td>
                  </tr>
                  <tr className="keyboardShortcutsRow">
                    <td className="labelRow">
                      <p className="labels keyboardShortcutsLabel">
                        Keyboard Shortcuts
                      </p>
                    </td>
                    <td>
                      <button
                        style={{
                          backgroundColor: "#fff4cb",
                          borderRadius: "50%",
                          border: "none",
                          aspectRatio: 1,
                        }}
                        className="keyboardShortcutsButton"
                        onClick={() => setShow(true)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="auto"
                          fill="#254E36"
                          class="bi bi-keyboard"
                          viewBox="0 0 16 16"
                          marginBottom="px"
                        >
                          <path d="M14 5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h12zM2 4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2z" />
                          <path d="M13 10.25a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm0-2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5 0A.25.25 0 0 1 8.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 8 8.75v-.5zm2 0a.25.25 0 0 1 .25-.25h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5a.25.25 0 0 1-.25-.25v-.5zm1 2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-5-2A.25.25 0 0 1 6.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 6 8.75v-.5zm-2 0A.25.25 0 0 1 4.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 4 8.75v-.5zm-2 0A.25.25 0 0 1 2.25 8h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 2 8.75v-.5zm11-2a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-2 0a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm-2 0A.25.25 0 0 1 9.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 9 6.75v-.5zm-2 0A.25.25 0 0 1 7.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 7 6.75v-.5zm-2 0A.25.25 0 0 1 5.25 6h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 5 6.75v-.5zm-3 0A.25.25 0 0 1 2.25 6h1.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-1.5A.25.25 0 0 1 2 6.75v-.5zm0 4a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-.5zm2 0a.25.25 0 0 1 .25-.25h5.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25h-5.5a.25.25 0 0 1-.25-.25v-.5z" />
                        </svg>
                      </button>
                      <div onClick={(e) => e.stopPropagation()}>
                        <Modal
                          dialogClassName="dialog"
                          style={{ paddingRight: "0px !important" }}
                          show={show}
                          onHide={modalClose}
                          centered
                        >
                          <Modal.Header
                            style={{
                              color: "#254E36",
                              backgroundColor: "#F5F5F5",
                            }}
                            className="modalBox"
                            closeButton
                          >
                            <Modal.Title
                              style={{
                                color: "#254E36",
                                backgroundColor: "#F5F5F5",
                              }}
                              className="modalBox"
                            >
                              Keyboard Shortcuts
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body
                            style={{
                              color: "#254E36",
                              backgroundColor: "#F5F5F5",
                            }}
                            className="modalBox"
                          >
                            <ul>
                              <p>
                                <b>Alt d</b> = Dark Mode
                              </p>
                              <p>
                                <b>Alt l</b> = Light Mode
                              </p>
                              <p>
                                <b>Alt /</b> = Home
                              </p>
                              <p>
                                <b>Alt p</b> = Project
                              </p>
                              <p>
                                <b>Alt c</b> = Parts and Contributions
                              </p>
                              <p>
                                <b>Alt h</b> = Human Practices
                              </p>
                              <p>
                                <b>Alt t</b> = Team
                              </p>
                              <p>
                                <b>Alt i</b> = Instagram
                              </p>
                              <p>
                                <b>Alt f</b> = Facebook
                              </p>
                              <p>
                                <b>Alt g</b> = Github
                              </p>
                              <p>
                                <b>Shift ArrowUp</b> = Scroll to Top
                              </p>
                              <p>
                                <b>Shift ArrowDown</b> = Scroll to Bottom
                              </p>
                              <p>
                                <b>Alt b</b> = Open Toolbar
                              </p>
                            </ul>
                          </Modal.Body>
                        </Modal>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            )
          ) : (
            <></>
          )}
        </Popup>
      </div>
    </div>
  );
};

export default Toolbar;
